import copy from "./copy";
/* <div v-copy> 单击复制 </div>
<div v-copy.dblclick> 双击复制 </div>
<div v-copy.icon> icon复制 </div> */

// 总的
const directives = {
  copy
};

export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key]);
    });
  }
};



// WEBPACK FOOTER //
// ./src/directives/index.js